<div class="menu">
  Menu
</div>

<button
  mat-icon-button
  class="close-button"
  (click)="drawer.toggle()"
>
  <mat-icon  routerLinkActive="active-link" svgIcon="Mobile Cancel"></mat-icon>
</button>
